let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("72zml")).then(() => parcelRequire('bvOVK'));